module.exports = __webpack_public_path__ + "media/src/assets/Images/BlackBuilding-c8bb80a96be46c8b712edd021a2f23fa.svg";